import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {CadastrosGeraisService} from "../../../modules/cadastro/services/cadastros-gerais.service";
import {ToastrService} from "ngx-toastr";
import {ClienteContato} from "../../../modules/cadastro/cliente/models/cliente-contato";
import {Cliente} from "../../../modules/cadastro/cliente/models/cliente";
import {TipoDocumentoCliente} from "../../../modules/cadastro/gerais/models/tipo-documento-cliente";
import {ClienteService} from "../../../modules/cadastro/services/cliente.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-cadastro-novo-contato',
  standalone: false,
  templateUrl: './cadastro-novo-contato.component.html',
  styleUrl: './cadastro-novo-contato.component.css'
})
export class CadastroNovoContatoComponent {
  @Input() showModal = false;
  @Output() fecharModalPai = new EventEmitter<void>();
  formCadastrar: FormGroup;
  formContatos: FormGroup;
  contatos: ClienteContato[] = [];
  cliente = new Cliente();
  tipoDocumentosCliente: TipoDocumentoCliente[] = [];
  mascaraDocumento = '';
  clienteExistente = false;


  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private clienteService: ClienteService,
              private geraisService: CadastrosGeraisService,
              private toastr: ToastrService) {
    this.construirFormulario();
    this.listarTiposDocumentosCliente();
  }

  fecharModal(){
    this.formContatos.reset();
    this.formCadastrar.reset();
    this.contatos = [];
    this.formCadastrar.reset();
    this.showModal = false;
    this.fecharModalPai.emit();
  }

  onBackgroundClick(event: Event): void {
    this.fecharModal();
  }

  salvar(){
    this.buscarClientePorDocumento();

    if(this.clienteExistente){
      this.toastr.error("Cliente já existe no banco de dados");
    }

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed)
      {
        this.preencherModelo();
        this.clienteService.adicionarNovoCliente(this.cliente).subscribe(
          (response) => {
            if (response.sucesso) {
              this.toastr.success("Cliente salvo com sucesso");
              this.fecharModal();
            } else {
              this.toastr.error("Erro ao salvar cliente - " + response.errors[0].mensagem);
            }
          },
          (error) => {
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
          }
        )
      }
    });

  }

  validarEmailJaExistente(): boolean{
    return this.contatos.some(x => x.email === this.formContatos.controls['email'].value);
  }

  validarTelefoneJaExistente(): boolean{
    return this.contatos.some(x => x.descricao === this.formContatos.controls['telefone'].value);
  }

  adicionarContato(){
    if(this.formContatos.controls['telefone'].value == undefined
      || this.formContatos.controls['email'].value == undefined){
      this.toastr.error("Preencha todos os campos");
      return;
    }

    if(this.formContatos.controls['telefone'].value == ''
      || this.formContatos.controls['email'].value == ''){
      this.toastr.error("Preencha todos os campos");
      return;
    }

    if(this.validarEmailJaExistente()){
      this.toastr.error("Email já existente no cadastro");
      return;
    }
    if(this.validarTelefoneJaExistente()){
      this.toastr.error("Telefone já existente no cadastro");
      return;
    }

    this.contatos.push(this.formContatos.value);
    this.formContatos.reset();
  }

  buscarClientePorDocumento(): void {
    let tipoDocumento = this.formCadastrar.controls['tipoDocumentoId'].value;
    let documento = this.formCadastrar.controls['documento'].value;
    this.clienteExistente = false;
    this.clienteService.selecionarPorTipoDocumentoeDocumento(tipoDocumento, documento).subscribe(response => {
      if(response.sucesso) {
        if(response.dados.length > 0 && response.dados.documento === documento){
          this.cliente = response.dados;
          this.clienteExistente = true;
        } else {
          this.clienteExistente = false;
        }
      } else {
        this.clienteExistente = false;
      }
    });
  }

  removerContato(telefone: string){
    let contatoARemover = this.contatos.find(x => x.descricao === telefone);
    if(contatoARemover){
      this.contatos.splice(this.contatos.indexOf(contatoARemover), 1);
    }
  }

  mascararDocumento(){
      let tipoDocumento = this.tipoDocumentosCliente
              .find(x => x.id == this.formCadastrar.controls['tipoDocumentoId'].value);
    if(tipoDocumento != undefined) {
      if(tipoDocumento.descricao.toUpperCase().includes("CPF")) {
        this.mascaraDocumento = "000.000.000-00";
      }else if(tipoDocumento.descricao.toUpperCase().includes("RG")){
        this.mascaraDocumento = "00.000.000-0";
      }else if(tipoDocumento.descricao.toUpperCase().includes("CNPJ")){
        this.mascaraDocumento = "00.000.000/0000-00";
      }
    }
  }

  private preencherModelo(){
    this.cliente.nome = this.formCadastrar.controls['nome'].value;
    this.cliente.tipoDocumentoId = this.formCadastrar.controls['tipoDocumentoId'].value;
    this.cliente.documento = this.formCadastrar.controls['documento'].value;
    this.cliente.contatos = this.contatos;
  }

  private listarTiposDocumentosCliente(){
    this.geraisService.selecionarListaTipoDocumentosCliente().subscribe(retorno => {
      if(retorno.sucesso){
        this.tipoDocumentosCliente = retorno.dados;
      }
    });
  }

  private construirFormulario(): void {
    this.formCadastrar = this.formBuilder.group({
      nome: ['', Validators.required],
      tipoDocumentoId: [0, Validators.required],
      documento: ['', Validators.required]
    });

    this.formContatos = this.formBuilder.group({
      telefone: [],
      email: [],
    });
  }
}
